<template>
	<div class="history">
		<div class="content">
			<el-timeline>
			  <el-timeline-item :timestamp="item.historyTime" placement="top" v-for="(item,index) in historyArr" :key="index">
				<el-card>
				  <h5>{{item.name}}</h5>
				  <p style="color: #999;margin-top:10px;">{{item.introduce}}</p>
				</el-card>
			  </el-timeline-item>
			</el-timeline>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				historyArr:[]
			}
		},
		mounted() {
			this.getHistory()
		},
		methods: {
			getHistory() {
				let vm = this
				this.axios.get('/api/history/findAll').then(res => {
					vm.historyArr = res.data.data
				})
			}
		},
	}
</script>

<style scoped>
	.history{
		width: 1100px;
		min-height:600px;
		margin: 0 auto;
		overflow: hidden;
	}
	.history .content{
		margin-top: 20px;
		margin-bottom: 20px;
		width: 1100px;
		min-height:600px;
	}
</style>
